import { CancelOutlined } from "@mui/icons-material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import NumberFormat from "react-number-format";
import { devLog } from "utils/devLog";

function FIMCMemberSearchForm(props) {
  const PHONE_NUMBER = "PHONE_NUMBER";
  const NAME = "NAME";
  const MEMBER_NUMBER = "MEMBER_NUMBER";
  const EMAIL = "EMAIL";

  const { t } = useTranslation();
  const formRef = useRef();
  const [memberNumber, setMemberNumber] = useState(props.memberNumber || "");
  const [phoneNumber, setPhoneNumber] = useState(props.phoneNumber || props.currState.Number || "");
  const [firstName, setFirstName] = useState(props.firstName || props.currState.FirstName || "");
  const [lastName, setLastName] = useState(props.lastName || props.currState.LastName || "");
  const [stateCode, setStateCode] = useState(props.stateCode || "");
  const [email, setEmail] = useState(props.email || "");

  const [searchTypes, setSearchTypes] = useState([
    { key: PHONE_NUMBER, value: t("FIMC.ContractSearch.DropdownOptions2") },
    { key: NAME, value: t("FIMC.ContractSearch.DropdownOptions3") },
    { key: MEMBER_NUMBER, value: t("FIMC.ContractSearch.DropdownOptions1") },
    { key: EMAIL, value: t("FIMC.ContractSearch.DropdownOptions4") },
  ]);

  const [selectedSearchTypes, setSelectedSearchTypes] = useState(props.searchType || PHONE_NUMBER);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        memberNumber: memberNumber,
        phoneNumber: phoneNumber.replace(/[()-]/g, ""),
        stateCode: stateCode,
        firstName: firstName,
        lastName: lastName,
        email: email,
        searchType: selectedSearchTypes,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        memberNumber: memberNumber,
        phoneNumber: phoneNumber.replace(/[()-]/g, ""),
        stateCode: stateCode,
        firstName: firstName,
        lastName: lastName,
        email: email,
        searchType: selectedSearchTypes,
      });
    }
    return false;
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((item) => item.key == selectedSearchTypes)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((type) => {
                return (
                  <Dropdown.Item
                    active={type.key === selectedSearchTypes}
                    onClick={(e) => setSelectedSearchTypes(type.key)}
                  >
                    {type.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/*Member Number*/}
          {selectedSearchTypes === MEMBER_NUMBER && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.ContractSearch.DropdownOptions1")}:</div>
                <input
                  type="text"
                  placeholder={t("FIMC.ContractSearch.DropdownOptions1")}
                  name="memberNumber"
                  className="input form-control required"
                  value={memberNumber}
                  onChange={(e) => {
                    setMemberNumber(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}
          {/* Phone Number */}
          {selectedSearchTypes === PHONE_NUMBER && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.ContractSearch.DropdownOptions2")}:</div>
                <NumberFormat
                  placeholder={t("description.ConfirmCustomerPrimaryContactNumber2")}
                  id="phone"
                  name="phone"
                  className="input form-control required"
                  value={phoneNumber}
                  format={"(###)-###-####"}
                  mask="_"
                  onChange={(e) => {
                    setPhoneNumber(e.target.value);
                  }}
                  required
                />
              </div>
            </>
          )}

          {/*First Name*/}
          {selectedSearchTypes === NAME && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.ContractSearch.DropdownSubOptions1")}:</div>
                <input
                  type="text"
                  placeholder={t("FIMC.ContractSearch.DropdownSubOptions1")}
                  name="firstName"
                  className="input form-control required"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/*Last Name*/}
          {selectedSearchTypes === NAME && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.ContractSearch.DropdownSubOptions2")}:</div>
                <input
                  type="text"
                  placeholder={t("FIMC.ContractSearch.DropdownSubOptions2")}
                  name="lastName"
                  className="input form-control required"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/*State*/}
          {selectedSearchTypes === NAME && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.ContractSearch.DropdownSubOptions3")}:</div>
                <input
                  type="text"
                  placeholder={"TN, VA, GA, etc."}
                  name="stateCode"
                  className="input form-control required"
                  value={stateCode}
                  onChange={(e) => {
                    setStateCode(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/*Email*/}
          {selectedSearchTypes === EMAIL && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.ContractSearch.DropdownOptions4")}:</div>
                <input
                  type="text"
                  placeholder={"example@gmail.com"}
                  name="email"
                  className="input form-control required"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}
          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default FIMCMemberSearchForm;
